var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEgs23(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 120,
    viewBox: "0 0 300 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 60
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20 L20 90 L30 90 L30 40 L50 75 L60 75 L80 40 L80 90 L90 90 L90 20 L75 20 L55 65 L35 20 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 20,
    width: 50,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 20,
    width: 10,
    height: 70
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(220, 60)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 45,
    fill: "#4A90E2",
    stroke: "#2E5C8A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 38,
    fill: "#FFFFFF",
    stroke: "#E0E0E0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#333333",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -32,
    x2: 0,
    y2: -28,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 0,
    x2: 28,
    y2: 0,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 32,
    x2: 0,
    y2: 28,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -32,
    y1: 0,
    x2: -28,
    y2: 0,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.6,
    y1: -22.6,
    x2: 20.5,
    y2: -20.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.6,
    y1: 22.6,
    x2: 20.5,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -22.6,
    y1: 22.6,
    x2: -20.5,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -22.6,
    y1: -22.6,
    x2: -20.5,
    y2: -20.5
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 18,
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: -25,
    y2: 0,
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#4A90E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgs23);
export default __webpack_public_path__ + "static/media/egs23.6f17358a64f3b7caa2cddfda641e49fc.svg";
export { ForwardRef as ReactComponent };